<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  batchComputed,
  authComputed,
  batchListMethod,
  siteListMethod,
  courseListMethod,
  userListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Add batch',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      batchError: null,
      isBatchError: false,
      isLoading: false,
      show: false,
      siteconfiglist: [],
      platformId: 0,
      assignedTo: [],
      assignedToPrev: [],
      courselist: [],
      teacherlist: [],
      userlist: [],
      courseId: [],
      teacherId: [],
      batchSuccess: '',
      isSuccess: false,
    }
  },
  computed: {
    ...batchComputed,
    ...authComputed,
  },
  methods: {
    ...batchListMethod,
    ...siteListMethod,
    ...courseListMethod,
    ...userListMethod,

    // save batch method
    saveBatch() {
      if (this.role === 'college') {
        let data = {
          id: this.data._id,
          name: this.name,
          course_id: this.courseId,
          assigned_to: [this.assignedTo, this.assignedToPrev],
          platform_id: this.platformId,
          teacher_id: this.teacherId,
        }
        this.updateBatchData({ data })
          .then((batch) => {
            this.isLoading = false
            this.batchSuccess = 'Batch Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.batchError = getError.message
            this.isBatchError = true
          })
      } else {
        let data = {
          id: this.data._id,
          name: this.name,
          course_id: this.courseId,
          assigned_to: this.assignedTo,
          platform_id: this.platformId,
        }
        this.updateBatchData({ data })
          .then((batch) => {
            this.isLoading = false
            this.batchSuccess = 'Batch Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.batchError = getError.message
            this.isBatchError = true
          })
      }
    },

    // get list of platform
    getListOfCollege() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getListOfCourses() {
      const filter = {
        sort: 'sort_order',
        order: '-1',
        limit: 100,
      }

      this.fetchCourseList({ filter })
        .then((courses) => {
          var listitems = []
          courses.docs.forEach((element) => {
            if (element.platform_id.includes(this.platformId)) {
              var ele = {}
              ele.text = element.name
              ele.value = {
                id: element._id,
                name: element.name,
              }
              listitems.push(ele)
            }
          })
          this.courselist = listitems
        })
        .catch((_error) => {})
    },

    getListOfUsers() {
      const filter = {
        limit: 3000,
        sort: 'first_name',
        order: '1',
      }
      this.fetchUserList({ filter })
        .then((users) => {
          var listitems = []
          users.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = {
              id: element._id,
              name: element.first_name + ' ' + element.last_name,
            }
            listitems.push(ele)

            this.userlist = listitems
          })
        })
        .catch((_error) => {})
    },

    getListOfTeachers() {
      const filter = {
        limit: 100,
        sort: 'first_name',
        order: '1',
      }
      this.fetchTeacherList({ filter })
        .then((teachers) => {
          var listitems = []
          teachers.docs.forEach((element) => {
            var ele = {}
            ele.text = element.first_name + ' ' + element.last_name
            ele.value = {
              id: element._id,
              name: element.first_name + ' ' + element.last_name,
            }
            listitems.push(ele)
            this.teacherlist = listitems
          })
        })
        .catch((_error) => {})
    },

    getData() {
      this.getListOfCollege()
      this.getListOfCourses()
      this.getListOfUsers()
      if (this.currentUser.user.role === 'college') {
        this.getListOfTeachers()
      }
      this.platformId = this.currentUser.user.platform_id
      let i = 0
      for (i = 0; i < this.data.course_id.length; i++) {
        this.courseId.push(this.data.course_id[i])
      }
      for (i = 0; i < this.data.assigned_to.length; i++) {
        this.assignedTo.push(this.data.assigned_to[i])
        this.assignedToPrev.push(this.data.assigned_to[i])
      }
      for (i = 0; i < this.data.teacher_id.length; i++) {
        this.teacherId.push(this.data.teacher_id[i])
      }
      this.name = this.data.name
    },

    resetModal() {
      this.courseId = []
      this.assignedTo = []
      this.assignedToPrev = []
      this.teacherId = []
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="batch-modal"
    title="Update "
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isBatchError"
          variant="danger"
          v-html="batchError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="batchSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveBatch">
          <b-form-group label="Batch Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Assigned By" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="data.assigned_by.email"
              type="text"
              disabled
              style="cursor:not-allowed;background:#e0d9d9;"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Select Course" label-for="input-1">
            <b-form-select
              v-model="courseId"
              :options="courselist"
              multiple
            ></b-form-select>
          </b-form-group>

          <b-form-group
            v-if="role === 'college' && data.teacher_id"
            label="Select Teacher"
            label-for="input-1"
          >
            <b-form-select v-model="teacherId" :options="teacherlist" multiple>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Select User" label-for="input-1">
            <b-form-select
              v-model="assignedTo"
              :options="userlist"
              multiple
            ></b-form-select>
          </b-form-group>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
